/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { ApiService } from '../../api/api.service';
import {
  LeadChatList,
  LeadDocumentType,
  LeadInformation,
  LeadMessageTemplate,
  MessageTemplate,
  LeadId,
  StreetTypes,
  ExecutiveList,
  AgentAssignment,
  ListBulkMessages,
  BulkMessagesRequest,
} from '@interfaces';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LeadService {
  private url: string = 'Leads';

  constructor(private apiService: ApiService) {}

  public getLeadMessages(
    leadId: string,
    page: number = 1,
    pageSize: number = 30,
  ): Observable<LeadChatList> {
    return this.apiService.get(
      `${this.url}/${leadId}/messages?page=${page}&pageSize=${pageSize}`,
    );
  }

  public updateLeadInformation(
    leadId: string,
    request: LeadInformation,
  ): Observable<any> {
    return this.apiService.patch(`${this.url}/${leadId}`, request);
  }

  public getLeadDocumentTypes(): Observable<LeadDocumentType[]> {
    return this.apiService.get(`${this.url}/identification-document-types`);
  }

  public getMessageTemplate(leadId: string): Observable<LeadMessageTemplate[]> {
    return this.apiService.get(`${this.url}/${leadId}/messages/templates`);
  }

  public sendMessageTemplate(
    template: MessageTemplate,
    leadId: string,
  ): Observable<LeadMessageTemplate[]> {
    return this.apiService.post(
      `${this.url}/${leadId}/messages/templates`,
      template,
    );
  }

  public chatBotMute(leadId: LeadId): Observable<any> {
    return this.apiService.post(
      `${this.url}/${leadId.chatId}/mute-bot/toggle`,
      {},
    );
  }

  public streetTypes(): Observable<StreetTypes[]> {
    return this.apiService.get(`${this.url}/street-types`, {});
  }

  public getAllAgents(leadId: string): Observable<ExecutiveList[]> {
    return this.apiService.get(`${this.url}/${leadId}/assignable-agents`, {});
  }

  public updateAgentAssignment(
    leadId: string,
    request: AgentAssignment,
  ): Observable<any> {
    return this.apiService.patch(
      `${this.url}/${leadId}/reassign-agent`,
      request,
    );
  }

  public getBulkMessages(
    businessLine: string[],
    fromDate: string,
    toDate: string,
  ): Observable<ListBulkMessages> {
    const queryParams: string[] = [
      businessLine?.length
        ? businessLine
            .map(b => `BusinessLine=${encodeURIComponent(b)}`)
            .join('&')
        : '',
      fromDate ? `FromDate=${fromDate}` : '',
      toDate ? `ToDate=${toDate}` : '',
    ].filter(Boolean);

    const url = `${this.url}/bulk-message/eligible?${queryParams.join('&')}`;

    return this.apiService.get(url);
  }

  public sendBulkMessage(bulkMessage: BulkMessagesRequest): Observable<any> {
    return this.apiService.post(`${this.url}/bulk-message`, bulkMessage);
  }
}
